import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import "./userlisting.scss";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import editicon from "../../../assets/images/edit-icon.svg";
import viewicon from "../../../assets/images/view-icon.svg";
import deactivateicon from "../../../assets/images/deactivate-icon.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import duplicatePlusIcon from "../../../assets/images/duplicate-plus-icon.svg";
import resetpasswordicon from "../../../assets/images/reset-password-icon.svg";
import { ReactSVG } from "react-svg";
import useUser from "../../../Hooks/useUser";
import Loading from "../../../components/LoadingPage/Loading";
import { useNavigate } from "react-router-dom";
import { selectedUser, setSelectedUser } from "../../../redux/user/userSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { toggleClass } from "../../../utils/commonUtils";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import CommonHeaderWithImpoExpo from "../../../components/commonHeaderWithImpoExpo/commonHeaderWithImpoExpo";
import moment from "moment";
import DublicateUserModel from "../../../components/DublicateUserModel/DublicateUserModel";
import { toast } from "react-toastify";
import { useModulePermissions, PermissionModule, PermissionIdentifier } from "../../../utils/permissionUtils";

const UserListing = () => {
  const loginUserId = useAppSelector(selectCurrentUserId);
  const defaultSelectedUser = useAppSelector(selectedUser);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    getUserList,
    getUsersListLoading,
    setUserActive,
    setUserStatusActiveLoading,
    setUserInActive,
    setUserStatusDeActiveLoading,
    deleteUserAPI,
    deleteUserLoading,
    exportUserAPI,
    exportUserLoading,
    importUserAPI,
    importUserLoading,
    onResetPassword,
    resetPasswordLoading,
  } = useUser();
  const [showModal, setShowModal] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [currentUser, setCurrentUser] = useState<any>();
  const [sortColumn, setSortColumn] = useState("userName");
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
  const defaultFilter = { searchText: "", active: true, sortColumn: sortColumn, sortDirection: sortDirection };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);
  const [showImportFileModal, setShowImportFileModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [importErrorDetails, setImportErrorDetails] = useState<any[]>([]);
  const [selectedRowId, setSelectedRowId] = useState<string>("");

  useEffect(() => {
    setSelectedRowId(defaultSelectedUser?.spSRXID || "");
  }, [defaultSelectedUser]);

  const handleRowSelection = (currInv: string) => {
    if (!currInv) return;
    setSelectedRowId(prevState => (prevState === currInv ? '' : currInv));
  }

  const resetPassword = async (userName: string) => {
    if (!userName) return;
    const { result } = await onResetPassword({
      userName,
      updatedBy: loginUserId,
    });
    if (result) {
      toast.success(result);
    }
  };

  const toggleModal = (user: any) => {
    dispatch(setSelectedUser(user));
    toggleClass();
    setShowModal(!showModal);
  };
  const navigateToView = (user: any) => {
    dispatch(setSelectedUser(user));
    navigate("/view-user");
  };
  const onClose = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const viewUser = (user: any) => {
    dispatch(setSelectedUser(user));
    navigate("/view-user");
  };
  const editUser = (user: any) => {
    dispatch(setSelectedUser(user));
    navigate("/edit-user");
  };
  const deleteUser = async () => {
    await deleteUserAPI({ id: currentUser.id, deletedBy: loginUserId });
    onClose();
    fetchUserList();
  };
  const updateStatus = async (user: any) => {
    if (user.isActive) {
      await setUserInActive({ id: user.id, updatedBy: loginUserId ?? "" });
    } else {
      await setUserActive({ id: user.id, updatedBy: loginUserId ?? "" });
    }
    fetchUserList();
  };
  const fetchUserList = () => {
    getUserList(searchFieldVal).then((res: any) => {
      if (res) {
        setUsersList(res);
      }
    });
  };
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };
  const handleSort = (columnName: string) => {
    // If the same column is clicked again, toggle the sort direction
    if (sortColumn === columnName) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
      setSearchFieldVal({ ...searchFieldVal, sortColumn: columnName, sortDirection: sortDirection === 'asc' ? 'desc' : 'asc' });
    }
    else {
      setSortColumn(columnName);
      setSortDirection('asc'); // Default to ascending when a new column is clicked
      setSearchFieldVal({ ...searchFieldVal, sortColumn: columnName, sortDirection: 'asc' });
    }
  };

  const handleExportUserList = async () => {
    const response = await exportUserAPI();
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${localStorage.getItem("profileClientId")?.toUpperCase() ?? ""}_Users_List_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  };
  const toggleImportXlsxModal = () => {
    setSelectedFile(null);
    toggleClass();
    setImportErrorDetails([]);
    setShowImportFileModal(!showImportFileModal);
  };
  const handleImportList = async (file: any) => {
    try {
      const formData = new FormData();
      formData.append("file", file || "");
      const response = await importUserAPI({ 'file': formData, 'createdBy': loginUserId });
      if (response.error && response.error.data?.status !== 200 && response.error.data?.result?.isSuccess === false) {
        if (response.error.data?.status === 400) {
          toast.error(response.error.data?.result?.errorMessage);
        }
        toast.error("Error!. File imported unsuccessfully");
        const errorData = response.error.data?.result?.data?.filter((data: any) => data.isValid === false);
        setImportErrorDetails(errorData);
      } else {
        toast.success("Success!. File imported successfully");
        toggleImportXlsxModal();
        fetchUserList();
      }
    }
    catch (error) { }
  }

  const isPermitted = useModulePermissions(PermissionModule.USER_MANAGEMENT);
  const isCreatePermitted = isPermitted(PermissionIdentifier.CREATE_USER);
  const isImportPermitted = isPermitted(PermissionIdentifier.IMPORT_USER);
  const isExportPermitted = isPermitted(PermissionIdentifier.EXPORT_USER);
  const isInactivePermitted = isPermitted(PermissionIdentifier.INACTIVE_USER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_USER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_USER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_USER);
  const isResetPasswordPermitted = isPermitted(PermissionIdentifier.RESET_PASSWORD_USER);

  useEffect(() => {
    // dispatch(setSelectedUser(null));
    fetchUserList();
  }, [searchFieldVal]);

  return (
    <div className="user-listing-wrapper">
      <CommonHeaderWithImpoExpo
        title={"Users"}
        buttonTitle="Add User"
        href="/create-user"
        disRecords={usersList.length || 0}
        totalRecords={usersList.length || 0}
        searchVal={searchFieldVal}
        setSearchVal={setSearchFieldVal}
        defaultFilter={defaultFilter}
        exportList={handleExportUserList}
        importList={handleImportList}
        showImportFileModal={showImportFileModal}
        setShowImportFileModal={setShowImportFileModal}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        toggleImportXlsxModal={toggleImportXlsxModal}
        importErrorDetails={{ data: importErrorDetails, module: "users" }}
        isAddPermitted={isCreatePermitted}
        isImportPermitted={isImportPermitted}
        isExportPermitted={isExportPermitted}
      />
      <div className="listing-table-wrapper">
        {[
          getUsersListLoading,
          setUserStatusActiveLoading,
          setUserStatusDeActiveLoading,
          deleteUserLoading,
          exportUserLoading,
          importUserLoading,
          resetPasswordLoading,
        ].some(Boolean) && (
            <Loading />
          )}
        <Table responsive="md" hover={true}>
          <thead>
            <tr>
              {/* <th>SRX ID</th> */}
              <th className="cursor-pointer" onClick={() => handleSort('userName')}>User Name {sortColumn === 'userName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('fName')}>First Name {sortColumn === 'fName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('mi')}>M.I {sortColumn === 'mi' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('lName')}>Last Name {sortColumn === 'lName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('secondaryUserName')}>Secondary User Name {sortColumn === 'secondaryUserName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('email')}>Email {sortColumn === 'email' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('isActive')}>Status {sortColumn === 'isActive' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('RoleName')}>Access Role {sortColumn === 'RoleName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('ClinicalRoleName')}>Clinical Role {sortColumn === 'ClinicalRoleName' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th className="cursor-pointer" onClick={() => handleSort('deaNumber')}>NPI {sortColumn === 'deaNumber' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {usersList?.map((x: any) => (
              <tr
                key={x?.spSRXID}
                className={[selectedRowId === x.spSRXID ? 'selected' : '', x?.role?.roleName === "SysAdmin" ? "disabled" : ""].filter(Boolean).join(' ')}
              >
                <td onClick={() => handleRowSelection(x?.spSRXID)}>
                  <span onClick={() => navigateToView(x)} className="clickable-text">
                    {x.userName}
                  </span>
                </td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.fName}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.mi || "-"}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.lName}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.secondaryUserName || "-"}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>
                  <span onClick={() => navigateToView(x)} className={`${x.email ? "clickable-text" : ""}`}>
                    {x.email || '-'}
                  </span>
                </td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>
                  <span className={`status-circle ${x.isActive ? "active" : "inactive"}`}>
                    {x.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.role.roleName}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.clinicalRole.roleName}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>{x.deaNumber || "NA"}</td>
                <td onClick={() => handleRowSelection(x?.spSRXID)}>
                  <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                      <ReactSVG
                        className="svg-box"
                        wrapper="span"
                        src={threedotvertical}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => viewUser(x)}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={viewicon}
                        />
                        View
                      </Dropdown.Item>
                      {isInactivePermitted && (
                        <Dropdown.Item onClick={() => updateStatus(x)}>
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={deactivateicon}
                          />
                          {x.isActive ? "Deactivate" : "Activate"}
                        </Dropdown.Item>
                      )}
                      {isEditPermitted && (
                        <Dropdown.Item onClick={() => editUser(x)}>
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={editicon}
                          />
                          Edit
                        </Dropdown.Item>
                      )}
                      {isDuplicatePermitted && (
                        <Dropdown.Item
                          onClick={() => {
                            setCurrentUser(x);
                            toggleDuplicateModal();
                          }}
                        >
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={duplicatePlusIcon}
                          />
                          Duplicate User
                        </Dropdown.Item>
                      )}
                      {isDeletePermitted && (
                        <Dropdown.Item
                          onClick={() => {
                            setCurrentUser(x);
                            toggleModal(x);
                          }}
                        >
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={deleteicon}
                          />
                          Delete
                        </Dropdown.Item>
                      )}
                      {isResetPasswordPermitted && (
                        <Dropdown.Item onClick={() => resetPassword(x.userName)}>
                          <ReactSVG
                            style={{ marginLeft: "-3px" }}
                            className="svg-box"
                            wrapper="span"
                            src={resetpasswordicon}
                          />
                          Reset Password
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <DeleteConfModel
        showModal={showModal}
        toggleModal={onClose}
        deleteAction={deleteUser}
        modelName={`User`}
        recordName={currentUser?.email || ""}
      />
      <DublicateUserModel
        selectedUser={currentUser}
        showModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        reloadListing={fetchUserList}
        userList={usersList}
      />
    </div>
  );
};

export default UserListing;
